import axios from 'axios';
import store from '../store/index'

const interceptorsBuild = () => {
  axios.interceptors.response.use((response) => {
    const build = store.state.user.build.number;

    if (response.status === 401 && window.location.pathname !== '/') {
      window.location.href = '/login';
    }

    if(build && build !== response.headers['build-no']) {
      store.commit('user/updateBuildReload', true);
    }

    return response;
  });
};

export default interceptorsBuild;